import nls from '../../../../nls/pt-BR.json';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentProgressTo,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { LayoutValuationResponse } from '../../../../redux/studies.model';
import { useEffect } from 'react';

export const QualifiedAudienceResponse: React.FC = () => {
  const { qualifiedAudience, layoutsValuationPrimaryResponse } =
    useSelector(studiesSelector);
  const valuations = Object.values(
    layoutsValuationPrimaryResponse as LayoutValuationResponse
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentProgressTo(5));
  }, []);
  return (
    <>
      <div style={{ marginTop: 12 }}>
        {valuations.map((valuation, index) => (
          <div key={index}>
            <div className="qualified-audience-response__row-container">
              <h6 className="layout-number">
                {nls.studyCreationGuide.steps.step4.layoutNumber} {index + 1}
              </h6>
              <p>
                {valuation.area}
                {nls.studyCreationGuide.steps.step5.sqMt}
              </p>
            </div>
            <div className="qualified-audience-response__row-container item">
              <p>{nls.studyCreationGuide.steps.step5.qualifiedPrimaryMarket}</p>
              <p>{qualifiedAudience?.[index]['primary_market']}</p>
            </div>

            {qualifiedAudience?.[index]['secondary_market'] && (
              <div className="qualified-audience-response__row-container item">
                <p>
                  {nls.studyCreationGuide.steps.step5.qualifiedSecondaryMarket}
                </p>
                <p>{qualifiedAudience?.[index]['secondary_market']}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};
